module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('success-page', {
    attrs: {
      "code": 0,
      "boletoUrl": null,
      "type": 'newVehicle',
      "novoCartao": true,
      "salesOrder": _vm.order
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-0aca14f9!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/validar-cartao.vue
// module id = 2042
// module chunks = 1